import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPostSegmentOcr, TSegmentOcr } from '../types';

export async function postSegmentOcr(body: TPostSegmentOcr): Promise<TSegmentOcr> {
  return mediaManagerClient
    .post('/api/v1/segment_ocr', emptyStringValues(body))
    .then(response => response as unknown as TSegmentOcr);
}

type MutationFn = typeof postSegmentOcr;

type TUsePostSegmentOcrParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostSegmentOcr({ config }: TUsePostSegmentOcrParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postSegmentOcr,
    onError(error) {
      addErrorNotification(t('No se ha podido crear el rótulo del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El rótulo del segmento se ha creado correctamente'));
    },
  });
}
